/**
 * TANVEER COLLECTION — Custom Theme JavaScript
 */
(function () {
  'use strict';

  /* ---- Hurry Up hotspots ---- */
  function initHotspots() {
    document.querySelectorAll('[data-tc-hurry-up]').forEach(function (section) {
      if (section.dataset.tcHurryInit === '1') return;
      section.dataset.tcHurryInit = '1';

      var hotspots = section.querySelectorAll('[data-tc-hotspot]');
      var items = section.querySelectorAll('[data-tc-product-item]');
      var images = section.querySelectorAll('[data-tc-hurry-image]');

      function activate(slide) {
        var slideId = String(slide);
        hotspots.forEach(function (h) {
          h.classList.toggle('is-active', h.getAttribute('data-tc-hurry-slide') === slideId);
        });
        items.forEach(function (item) {
          item.classList.toggle('is-active', item.getAttribute('data-tc-hurry-slide') === slideId);
        });
        if (!images.length) return;
        var target = section.querySelector('[data-tc-hurry-image="' + slideId + '"]');
        if (!target) return;
        images.forEach(function (img) {
          img.classList.toggle('is-active', img === target);
        });
      }

      hotspots.forEach(function (hotspot) {
        hotspot.addEventListener('click', function (e) {
          e.preventDefault();
          activate(hotspot.getAttribute('data-tc-hurry-slide'));
        });
      });

      items.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          activate(item.getAttribute('data-tc-hurry-slide'));
        });
      });

      if (hotspots.length) {
        activate(hotspots[0].getAttribute('data-tc-hurry-slide'));
      } else if (images.length) {
        activate(images[0].getAttribute('data-tc-hurry-image'));
      }
    });
  }

  /* ---- Countdown timer ---- */
  function initCountdowns() {
    document.querySelectorAll('[data-tc-countdown-section]').forEach(function (section) {
      var endStr = section.getAttribute('data-countdown-end');
      var hideExpired = section.getAttribute('data-hide-expired') === 'true';
      var countdownEl = section.querySelector('[data-tc-countdown]');
      if (!endStr || !countdownEl) return;

      var endDate = new Date(endStr);
      if (isNaN(endDate.getTime())) return;

      var daysEl = countdownEl.querySelector('[data-countdown-days]');
      var hoursEl = countdownEl.querySelector('[data-countdown-hours]');
      var minutesEl = countdownEl.querySelector('[data-countdown-minutes]');
      var secondsEl = countdownEl.querySelector('[data-countdown-seconds]');

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        var now = new Date();
        var diff = endDate.getTime() - now.getTime();

        if (diff <= 0) {
          if (hideExpired) {
            countdownEl.classList.add('is-expired');
          } else {
            if (daysEl) daysEl.textContent = '00';
            if (hoursEl) hoursEl.textContent = '00';
            if (minutesEl) minutesEl.textContent = '00';
            if (secondsEl) secondsEl.textContent = '00';
          }
          return;
        }

        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      window.setInterval(tick, 1000);
    });
  }

  /* ---- Shop the Look hotspots ---- */
  function initShopLookHotspots() {
    document.querySelectorAll('[data-tc-shop-look-hero]').forEach(function (hero) {
      var hotspots = hero.querySelectorAll('[data-tc-shop-look-hotspot]');
      var popups = hero.parentElement.querySelectorAll('[data-tc-shop-look-popup]');

      function activate(index) {
        hotspots.forEach(function (h) {
          h.classList.toggle('is-active', h.getAttribute('data-index') === String(index));
        });
        popups.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-index') === String(index));
        });
      }

      hotspots.forEach(function (hotspot) {
        hotspot.addEventListener('click', function () {
          activate(hotspot.getAttribute('data-index'));
        });
      });

      if (hotspots.length) activate(hotspots[0].getAttribute('data-index'));
    });
  }

  /* ---- Mobile sticky add to cart ---- */
  function initStickyATC() {
    document.querySelectorAll('[data-tc-sticky-atc]').forEach(function (stickyBar) {
      var sectionId = stickyBar.getAttribute('data-section-id');
      var productInfo = document.querySelector('#MainProduct-' + sectionId);
      var buyTarget = productInfo && productInfo.querySelector('[data-tc-product-buy]');
      var submitBtn = productInfo && productInfo.querySelector('.product-form [type="submit"]');
      var stickyBtn = stickyBar.querySelector('[data-tc-sticky-submit]');
      var priceEl = stickyBar.querySelector('[data-tc-sticky-price]');
      var variantEl = stickyBar.querySelector('[data-tc-sticky-variant]');
      var imageEl = stickyBar.querySelector('[data-tc-sticky-image]');

      if (!buyTarget || !stickyBtn) return;

      if (submitBtn) {
        stickyBtn.addEventListener('click', function () {
          if (!submitBtn.disabled) submitBtn.click();
        });

        function syncButtonState() {
          stickyBtn.disabled = submitBtn.disabled;
          stickyBtn.textContent = submitBtn.textContent;
        }

        syncButtonState();
        var btnObserver = new MutationObserver(syncButtonState);
        btnObserver.observe(submitBtn, { attributes: true, childList: true, subtree: true });
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (!event.data || !event.data.variant) return;
          if (String(event.data.sectionId) !== String(sectionId)) return;
          var variant = event.data.variant;
          if (priceEl && event.data.html) {
            var priceWrap = event.data.html.getElementById('price-' + sectionId);
            var priceText = priceWrap && priceWrap.querySelector('.tc-product__price');
            if (priceText) priceEl.textContent = priceText.textContent.trim();
          }
          if (variantEl) {
            variantEl.textContent = variant.title === 'Default Title' ? '' : variant.title;
          }
          if (imageEl && variant.featured_media && variant.featured_media.preview_image) {
            imageEl.src = variant.featured_media.preview_image.src;
          }
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            var visible = entries[0].isIntersecting;
            stickyBar.classList.toggle('is-visible', !visible);
            document.body.classList.toggle('tc-has-sticky-atc', !visible);
          },
          { threshold: 0, rootMargin: '0px 0px -40px 0px' }
        );
        observer.observe(buyTarget);
      }
    });
  }

  /* ---- Shop the look carousel and video modal ---- */
  function initShopLookScroll() {
    document.querySelectorAll('[data-tc-shop-look]').forEach(function (section) {
      if (section.dataset.tcShopLookReady === 'true') return;
      section.dataset.tcShopLookReady = 'true';

      var track = section.querySelector('[data-tc-shop-look-track]');
      var prevBtn = section.querySelector('[data-tc-shop-look-prev]');
      var nextBtn = section.querySelector('[data-tc-shop-look-next]');
      if (!track) return;

      function getScrollAmount() {
        var card = track.querySelector('[data-tc-shop-look-card]');
        if (!card) return track.clientWidth * 0.8;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var atStart = track.scrollLeft <= 2;
        var atEnd = maxScroll <= 2 || track.scrollLeft >= maxScroll - 2;
        var isMobile = window.matchMedia('(max-width: 749px)').matches;

        if (prevBtn) {
          prevBtn.disabled = atStart;
          if (isMobile) {
            prevBtn.hidden = atStart;
          } else {
            prevBtn.hidden = false;
          }
        }
        if (nextBtn) {
          nextBtn.disabled = atEnd;
          if (isMobile) {
            nextBtn.hidden = atEnd;
          } else {
            nextBtn.hidden = false;
          }
        }
      }

      function scrollByDir(dir) {
        track.scrollBy({ left: getScrollAmount() * dir, behavior: 'smooth' });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollByDir(-1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollByDir(1);
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      var isDown = false;
      var startX;
      var scrollLeft;
      var didDrag = false;
      var modal = section.querySelector('[data-tc-shop-look-modal]');
      var modalVideo = section.querySelector('[data-tc-shop-look-modal-video]');
      var modalCloseEls = section.querySelectorAll('[data-tc-shop-look-modal-close]');

      track.addEventListener('mousedown', function (e) {
        if (e.target.closest('a, button')) return;
        isDown = true;
        didDrag = false;
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        track.style.cursor = 'grabbing';
      });

      track.addEventListener('mouseleave', function () {
        isDown = false;
        track.style.cursor = 'grab';
      });

      track.addEventListener('mouseup', function () {
        isDown = false;
        track.style.cursor = 'grab';
      });

      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 1.5;
        if (Math.abs(walk) > 4) didDrag = true;
        track.scrollLeft = scrollLeft - walk;
      });

      function playPreview(video) {
        if (!video) return;
        video.muted = true;
        video.loop = true;
        video.autoplay = true;
        video.playsInline = true;
        video.controls = false;
        var previewPromise = video.play();
        if (previewPromise && typeof previewPromise.catch === 'function') {
          previewPromise.catch(function () {});
        }
      }

      function clearModalVideo() {
        if (!modalVideo) return;
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        while (modalVideo.firstChild) {
          modalVideo.removeChild(modalVideo.firstChild);
        }
        modalVideo.load();
      }

      function closeModal() {
        if (!modal || modal.hasAttribute('hidden')) return;
        clearModalVideo();
        modal.setAttribute('hidden', '');
        document.body.classList.remove('tc-shop-look-modal-open');
        section.querySelectorAll('[data-tc-shop-look-video]').forEach(function (previewVideo) {
          playPreview(previewVideo);
        });
      }

      function openModalFromCard(card) {
        if (!modal || !modalVideo) return;
        var previewVideo = card.querySelector('[data-tc-shop-look-video]');
        if (!previewVideo) return;

        clearModalVideo();

        var poster = previewVideo.getAttribute('poster');
        if (poster) {
          modalVideo.setAttribute('poster', poster);
        } else {
          modalVideo.removeAttribute('poster');
        }

        previewVideo.querySelectorAll('source').forEach(function (sourceEl) {
          var newSource = document.createElement('source');
          newSource.src = sourceEl.src;
          if (sourceEl.type) newSource.type = sourceEl.type;
          modalVideo.appendChild(newSource);
        });

        modal.removeAttribute('hidden');
        document.body.classList.add('tc-shop-look-modal-open');

        modalVideo.currentTime = 0;
        modalVideo.loop = false;
        modalVideo.controls = true;
        modalVideo.muted = false;
        modalVideo.playsInline = true;
        modalVideo.load();

        var modalPlayPromise = modalVideo.play();
        if (modalPlayPromise && typeof modalPlayPromise.catch === 'function') {
          modalPlayPromise.catch(function () {
            modalVideo.muted = true;
            var fallbackPlay = modalVideo.play();
            if (fallbackPlay && typeof fallbackPlay.catch === 'function') {
              fallbackPlay.catch(function () {});
            }
          });
        }

        if (modalCloseEls.length) {
          modalCloseEls[0].focus();
        }
      }

      section.querySelectorAll('[data-tc-shop-look-card]').forEach(function (card) {
        var video = card.querySelector('[data-tc-shop-look-video]');
        var trigger = card.querySelector('[data-tc-shop-look-video-trigger]');
        if (!video) return;

        playPreview(video);

        if (trigger) {
          trigger.addEventListener('click', function (e) {
            if (didDrag) return;
            e.preventDefault();
            openModalFromCard(card);
          });
        }
      });

      modalCloseEls.forEach(function (closeEl) {
        closeEl.addEventListener('click', function () {
          closeModal();
        });
      });

      section.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeModal();
        }
      });
    });
  }

  function initWhatsApp() {
    document.querySelectorAll('[data-tc-whatsapp]').forEach(function (btn) {
      var offset = btn.getAttribute('data-sticky-offset') || '72';
      btn.style.setProperty('--tc-wa-sticky-offset', offset + 'px');
    });
  }

  function initMobileNav() {
    if (window.innerWidth > 749) return;

    var nav = document.querySelector('[data-tc-mobile-nav]');
    if (!nav) return;

    document.body.classList.add('tc-has-mobile-nav');

    var navHeight = nav.offsetHeight || 56;
    document.documentElement.style.setProperty('--tc-mobile-nav-height', navHeight + 'px');
    document.documentElement.style.setProperty('--tc-mobile-bottom-offset', 'calc(' + navHeight + 'px + env(safe-area-inset-bottom, 0px))');

    var cartBadge = nav.querySelector('[data-tc-mobile-cart-count]');
    var headerCartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');

    function syncCartCount() {
      if (!cartBadge) return;
      var count = 0;
      if (headerCartBubble) {
        count = parseInt(headerCartBubble.textContent, 10) || 0;
      }
      cartBadge.textContent = count;
      cartBadge.hidden = false;
      if (count > 0) {
        cartBadge.removeAttribute('data-empty');
      } else {
        cartBadge.setAttribute('data-empty', 'true');
      }
    }

    syncCartCount();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncCartCount);
    }

    document.addEventListener('cart:updated', syncCartCount);

    var cartLink = document.getElementById('tc-mobile-nav-cart');
    if (cartLink && document.querySelector('cart-drawer')) {
      cartLink.addEventListener('click', function (e) {
        var drawerTrigger = document.querySelector('#cart-icon-bubble');
        if (drawerTrigger && window.innerWidth <= 749) {
          e.preventDefault();
          drawerTrigger.click();
        }
      });
    }

    /* Force Account navigation (same-domain /account/login like Al-Imran) */
    nav.querySelectorAll('[data-tc-account-link], [data-tc-mobile-nav-link="account"]').forEach(function (link) {
      if (link.dataset.tcAccountBound === '1') return;
      link.dataset.tcAccountBound = '1';
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href === '#') return;
        e.preventDefault();
        window.location.assign(href);
      });
    });
  }

  /* ---- Buy now — add to cart, then straight to checkout ---- */
  function initBuyNow() {
    document.querySelectorAll('[data-tc-buy-now]').forEach(function (btn) {
      if (btn.dataset.tcBuyNowBound === '1') return;
      btn.dataset.tcBuyNowBound = '1';

      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        var formId = btn.getAttribute('data-product-form');
        var form = formId ? document.getElementById(formId) : btn.closest('form');
        if (!form) return;

        var variantInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var variantId = variantInput && variantInput.value;
        if (!variantId || variantInput.disabled) return;

        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            window.location.href = root + 'checkout';
          })
          .catch(function () {
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
            var submitBtn = form.querySelector('[type="submit"][name="add"]');
            if (submitBtn) submitBtn.click();
          });
      });
    });
  }

  /* ---- Promotional social counters (session-based) ---- */
  function initSocialProof() {
    var storageOk = false;
    try {
      storageOk = typeof sessionStorage !== 'undefined';
    } catch (e) {
      storageOk = false;
    }

    function randInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      if (max < min) return min;
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function storageKey(el) {
      return 'tc_social_' + (el.getAttribute('data-tc-social') || 'x') + '_' + (el.getAttribute('data-product-id') || '0');
    }

    function readSession(el) {
      if (!storageOk) return null;
      try {
        var raw = sessionStorage.getItem(storageKey(el));
        if (!raw) return null;
        var n = parseInt(raw, 10);
        return isNaN(n) ? null : n;
      } catch (e) {
        return null;
      }
    }

    function writeSession(el, value) {
      if (!storageOk) return;
      try {
        sessionStorage.setItem(storageKey(el), String(value));
      } catch (e) {}
    }

    function animateCount(el, from, to, duration) {
      var countEl = el.querySelector('[data-tc-social-count]');
      if (!countEl) return;
      from = Math.round(from);
      to = Math.round(to);
      if (from === to) {
        countEl.textContent = String(to);
        return;
      }
      var start = null;
      duration = duration || 500;
      function frame(ts) {
        if (start === null) start = ts;
        var t = Math.min(1, (ts - start) / duration);
        var eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        countEl.textContent = String(Math.round(from + (to - from) * eased));
        if (t < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }

    document.querySelectorAll('[data-tc-social]').forEach(function (el) {
      if (el.dataset.tcSocialInit === '1') return;
      el.dataset.tcSocialInit = '1';

      var mode = el.getAttribute('data-tc-social');
      var min = parseInt(el.getAttribute('data-min'), 10) || 1;
      var max = parseInt(el.getAttribute('data-max'), 10) || min;
      if (max < min) max = min;
      var refreshMin = (parseInt(el.getAttribute('data-refresh-min'), 10) || 8) * 1000;
      var refreshMax = (parseInt(el.getAttribute('data-refresh-max'), 10) || 15) * 1000;
      if (refreshMax < refreshMin) refreshMax = refreshMin;

      var current = readSession(el);
      if (current === null) {
        current = parseInt(el.getAttribute('data-initial'), 10);
        if (isNaN(current)) current = randInt(min, max);
        current = clamp(current, min, max);
        writeSession(el, current);
      } else {
        current = clamp(current, min, max);
      }

      var countEl = el.querySelector('[data-tc-social-count]');
      if (countEl) countEl.textContent = String(current);

      function schedule() {
        var delay = randInt(refreshMin, refreshMax);
        el._tcSocialTimer = window.setTimeout(tick, delay);
      }

      function tick() {
        var next;
        if (mode === 'sold') {
          var delta = randInt(-2, 3);
          if (delta === 0) delta = 1;
          next = clamp(current + delta, min, max);
          if (next === current) {
            next = current >= max ? current - 1 : current + 1;
            next = clamp(next, min, max);
          }
        } else {
          next = randInt(min, max);
          var guard = 0;
          while (next === current && max > min && guard < 6) {
            next = randInt(min, max);
            guard += 1;
          }
        }
        animateCount(el, current, next, mode === 'sold' ? 450 : 550);
        current = next;
        writeSession(el, current);
        schedule();
      }

      schedule();
    });
  }

  /* ---- Product tabs — collapsible rows (description / shipping / reviews) ---- */
  function initProductTabs() {
    document.querySelectorAll('[data-tc-product-tabs]').forEach(function (root) {
      if (root.dataset.tcTabsReady === '1') return;
      root.dataset.tcTabsReady = '1';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-tc-accordion-item]'));
      var singleOpen = root.getAttribute('data-single-open') !== 'false';

      function panelOf(item) {
        return item.querySelector('[data-tc-accordion-panel]');
      }

      function toggleOf(item) {
        return item.querySelector('[data-tc-accordion-toggle]');
      }

      function open(item) {
        var panel = panelOf(item);
        if (!panel) return;

        item.classList.add('is-open');
        toggleOf(item).setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';

        // Release the fixed height so late-loading content (reviews apps) can grow.
        var release = function (e) {
          if (e && e.propertyName !== 'max-height') return;
          if (item.classList.contains('is-open')) panel.style.maxHeight = 'none';
          panel.removeEventListener('transitionend', release);
        };
        panel.addEventListener('transitionend', release);
      }

      function close(item) {
        var panel = panelOf(item);
        if (!panel) return;

        panel.style.maxHeight = panel.scrollHeight + 'px';
        item.classList.remove('is-open');
        toggleOf(item).setAttribute('aria-expanded', 'false');

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            panel.style.maxHeight = '0px';
          });
        });
      }

      items.forEach(function (item) {
        var panel = panelOf(item);
        var toggle = toggleOf(item);
        if (!panel || !toggle) return;

        panel.style.maxHeight = item.classList.contains('is-open') ? 'none' : '0px';

        toggle.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          if (singleOpen && !isOpen) {
            items.forEach(function (other) {
              if (other !== item && other.classList.contains('is-open')) close(other);
            });
          }

          if (isOpen) {
            close(item);
          } else {
            open(item);
          }
        });
      });
    });
  }

  /* ---- Wishlist (localStorage, Al-Imran style) ---- */
  /* Legacy stub — real logic is in initWishlistSafe below */
  function initWishlist() {
    return;
    var STORAGE_KEY = 'tc_wishlist_v1';
    var moneyFormat = (window.theme && window.theme.moneyFormat) || null;

    function read() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    }

    function write(list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('tc:wishlist:update', { detail: { count: list.length, items: list } }));
    }

    function formatMoney(cents) {
      if (cents == null || cents === '') return '';
      var value = (Number(cents) / 100).toFixed(2);
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return 'Rs.' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function isSaved(id) {
      id = String(id);
      return read().some(function (item) { return String(item.id) === id; });
    }

    function syncButtons() {
      document.querySelectorAll('[data-tc-wishlist-toggle]').forEach(function (btn) {
        var id = btn.getAttribute('data-product-id');
        if (!id) return;
        var active = isSaved(id);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      });
    }

    function syncCounts() {
      var count = read().length;
      document.querySelectorAll('[data-tc-wishlist-count]').forEach(function (el) {
        el.textContent = String(count);
        if (count > 0) {
          el.hidden = false;
          el.removeAttribute('hidden');
        } else {
          el.hidden = true;
          el.setAttribute('hidden', '');
        }
      });
    }

    function toggle(btn) {
      var id = btn.getAttribute('data-product-id');
      if (!id) return;
      var list = read();
      var idx = list.findIndex(function (item) { return String(item.id) === String(id); });
      if (idx >= 0) {
        list.splice(idx, 1);
      } else {
        list.unshift({
          id: String(id),
          handle: btn.getAttribute('data-product-handle') || '',
          url: btn.getAttribute('data-product-url') || '',
          title: btn.getAttribute('data-product-title') || '',
          price: Number(btn.getAttribute('data-product-price') || 0),
          compare: Number(btn.getAttribute('data-product-compare') || 0),
          image: btn.getAttribute('data-product-image') || '',
          available: btn.getAttribute('data-product-available') !== 'false',
        });
      }
      write(list);
      syncButtons();
      syncCounts();
      renderPage();
    }

    function removeById(id) {
      var list = read().filter(function (item) { return String(item.id) !== String(id); });
      write(list);
      syncButtons();
      syncCounts();
      renderPage();
    }

    function cardHtml(item) {
      var compareHtml = '';
      if (item.compare && item.compare > item.price) {
        compareHtml = '<span class="tc-card__compare">' + formatMoney(item.compare) + '</span>';
      }
      var imageHtml = item.image
        ? '<img class="tc-card__media tc-card__media--primary" src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="600" height="800">'
        : '';
      return (
        '<div class="tc-card" data-wishlist-id="' + item.id + '">' +
          '<div class="tc-card__media-wrap">' +
            '<a href="' + (item.url || '#') + '" class="tc-card__media-link" tabindex="-1" aria-hidden="true">' + imageHtml + '</a>' +
            '<button type="button" class="tc-card__wishlist is-active" aria-label="Remove from wishlist" data-tc-wishlist-remove="' + item.id + '">' +
              '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M12.1 20.3l-1.1-1C5.7 14.2 2.5 11.3 2.5 7.8A4.3 4.3 0 0 1 6.8 3.5c1.5 0 2.9.7 3.8 1.8A4.7 4.7 0 0 1 14.4 3.5a4.3 4.3 0 0 1 4.3 4.3c0 3.5-3.2 6.4-8.5 11.5l-1.1 1z"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="tc-card__info">' +
            '<h3 class="tc-card__title"><a href="' + (item.url || '#') + '">' + (item.title || '') + '</a></h3>' +
            '<div class="tc-card__prices"><span class="tc-card__price">' + formatMoney(item.price) + '</span>' + compareHtml + '</div>' +
          '</div>' +
        '</div>'
      );
    }

    function renderPage() {
      var page = document.querySelector('[data-tc-wishlist-page]');
      if (!page) return;
      var list = read();
      var empty = page.querySelector('[data-tc-wishlist-empty]');
      var grid = page.querySelector('[data-tc-wishlist-grid]');
      var countEl = page.querySelector('[data-tc-wishlist-page-count]');
      if (countEl) {
        countEl.textContent = list.length === 1 ? '1 item' : list.length + ' items';
        countEl.hidden = list.length === 0;
      }
      if (!list.length) {
        if (empty) empty.hidden = false;
        if (grid) {
          grid.hidden = true;
          grid.innerHTML = '';
        }
        return;
      }
      if (empty) empty.hidden = true;
      if (grid) {
        grid.hidden = false;
        grid.innerHTML = list.map(cardHtml).join('');
      }
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-tc-wishlist-toggle]');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        toggle(toggle);
        return;
      }
      var removeBtn = e.target.closest('[data-tc-wishlist-remove]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        removeById(removeBtn.getAttribute('data-tc-wishlist-remove'));
      }
    });

    // Fix shadowed name: use local toggleProduct instead
    // (rebind after correcting)
  }

  function initWishlistSafe() {
    var STORAGE_KEY = 'tc_wishlist_v1';

    function read() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    }

    function write(list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {}
    }

    function formatMoney(cents) {
      var value = (Number(cents) / 100).toFixed(2);
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try {
          return window.Shopify.formatMoney(cents);
        } catch (e) {}
      }
      return 'Rs.' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function isSaved(id) {
      id = String(id);
      return read().some(function (item) { return String(item.id) === id; });
    }

    function syncButtons() {
      document.querySelectorAll('[data-tc-wishlist-toggle]').forEach(function (btn) {
        var id = btn.getAttribute('data-product-id');
        if (!id) return;
        var active = isSaved(id);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      });
    }

    function syncCounts() {
      var count = read().length;
      document.querySelectorAll('[data-tc-wishlist-count]').forEach(function (el) {
        el.textContent = String(count);
        if (count > 0) {
          el.hidden = false;
          el.removeAttribute('hidden');
        } else {
          el.hidden = true;
          el.setAttribute('hidden', '');
        }
      });
    }

    function toggleProduct(btn) {
      var id = btn.getAttribute('data-product-id');
      if (!id) return;
      var list = read();
      var idx = list.findIndex(function (item) { return String(item.id) === String(id); });
      if (idx >= 0) {
        list.splice(idx, 1);
      } else {
        list.unshift({
          id: String(id),
          handle: btn.getAttribute('data-product-handle') || '',
          url: btn.getAttribute('data-product-url') || '',
          title: btn.getAttribute('data-product-title') || '',
          price: Number(btn.getAttribute('data-product-price') || 0),
          compare: Number(btn.getAttribute('data-product-compare') || 0),
          image: btn.getAttribute('data-product-image') || '',
          available: btn.getAttribute('data-product-available') !== 'false',
        });
      }
      write(list);
      syncButtons();
      syncCounts();
      renderPage();
    }

    function removeById(id) {
      write(read().filter(function (item) { return String(item.id) !== String(id); }));
      syncButtons();
      syncCounts();
      renderPage();
    }

    function cardHtml(item) {
      var compareHtml = '';
      if (item.compare && item.compare > item.price) {
        compareHtml = '<span class="tc-card__compare">' + formatMoney(item.compare) + '</span>';
      }
      var imageHtml = item.image
        ? '<img class="tc-card__media tc-card__media--primary" src="' + item.image + '" alt="" loading="lazy" width="600" height="800">'
        : '';
      var safeTitle = (item.title || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return (
        '<div class="tc-card" data-wishlist-id="' + item.id + '">' +
          '<div class="tc-card__media-wrap">' +
            '<a href="' + (item.url || '#') + '" class="tc-card__media-link" tabindex="-1" aria-hidden="true">' + imageHtml + '</a>' +
            '<button type="button" class="tc-card__wishlist is-active" aria-label="Remove from wishlist" data-tc-wishlist-remove="' + item.id + '">' +
              '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M12.1 20.3l-1.1-1C5.7 14.2 2.5 11.3 2.5 7.8A4.3 4.3 0 0 1 6.8 3.5c1.5 0 2.9.7 3.8 1.8A4.7 4.7 0 0 1 14.4 3.5a4.3 4.3 0 0 1 4.3 4.3c0 3.5-3.2 6.4-8.5 11.5l-1.1 1z"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="tc-card__info">' +
            '<h3 class="tc-card__title"><a href="' + (item.url || '#') + '">' + safeTitle + '</a></h3>' +
            '<div class="tc-card__prices"><span class="tc-card__price">' + formatMoney(item.price) + '</span>' + compareHtml + '</div>' +
          '</div>' +
        '</div>'
      );
    }

    function renderPage() {
      var page = document.querySelector('[data-tc-wishlist-page]');
      if (!page) return;
      var list = read();
      var empty = page.querySelector('[data-tc-wishlist-empty]');
      var grid = page.querySelector('[data-tc-wishlist-grid]');
      var countEl = page.querySelector('[data-tc-wishlist-page-count]');
      if (countEl) {
        countEl.textContent = list.length === 1 ? '1 item' : list.length + ' items';
        countEl.hidden = list.length === 0;
      }
      if (!list.length) {
        if (empty) empty.hidden = false;
        if (grid) {
          grid.hidden = true;
          grid.innerHTML = '';
        }
        return;
      }
      if (empty) empty.hidden = true;
      if (grid) {
        grid.hidden = false;
        grid.innerHTML = list.map(cardHtml).join('');
      }
    }

    if (!document.documentElement.dataset.tcWishlistBound) {
      document.documentElement.dataset.tcWishlistBound = '1';
      document.addEventListener('click', function (e) {
        var toggleBtn = e.target.closest('[data-tc-wishlist-toggle]');
        if (toggleBtn) {
          e.preventDefault();
          e.stopPropagation();
          toggleProduct(toggleBtn);
          return;
        }
        var removeBtn = e.target.closest('[data-tc-wishlist-remove]');
        if (removeBtn) {
          e.preventDefault();
          e.stopPropagation();
          removeById(removeBtn.getAttribute('data-tc-wishlist-remove'));
        }
      });
    }

    syncButtons();
    syncCounts();
    renderPage();
  }

  /* ---- Account links (header / drawer) — force navigation ---- */
  function initAccountLinks() {
    document.querySelectorAll('[data-tc-account-link]').forEach(function (link) {
      if (link.dataset.tcAccountBound === '1') return;
      link.dataset.tcAccountBound = '1';
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href === '#') return;
        e.preventDefault();
        window.location.assign(href);
      });
    });
  }

  function init() {
    initHotspots();
    initCountdowns();
    initShopLookHotspots();
    initStickyATC();
    initShopLookScroll();
    initWhatsApp();
    initMobileNav();
    initAccountLinks();
    initBuyNow();
    initSocialProof();
    initProductTabs();
    initWishlistSafe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
